<template>
    <v-layout row justify-space-around mx-5 mb-10 :class="{'column':$vuetify.breakpoint.mdAndDown}">

        <v-flex xs4 :class="{'mb-5':$vuetify.breakpoint.mdAndDown}" v-for="(item,i) in data" :key="i">

            <v-card class="cardStats py-5 px-7 mx-3 mb-4" :style="[$vuetify.breakpoint.mdAndUp ? {'height':'200px'}:{}]">
                <v-layout style="width: 100%;height: 100%" :class="{ 'column':$vuetify.breakpoint.smAndDown }">
                    <v-flex class="align-center" :class="{ 'mr-12':$vuetify.breakpoint.mdAndUp,'align-self-center':$vuetify.breakpoint.smAndDown }" style="display: flex">
                        <img style="width: 79px" :src="require('../assets/icon/card'+(i+1)+'.png')">
                    </v-flex>
                    <v-flex>
                        <v-layout column>
                            <v-flex mb-2 style="font-size: 25px;color: #FF5100">
                                <!-- TODO: Waiting for Integrate API -->
                                {{  formatNumber(item.value) }}
                            </v-flex>
                            <v-flex class="text-left" style="font-size: 18px">
                                {{ item.topic[`name_${language}`] }}
                                {{ $t('general.year-prefix') }}
                                {{ yearFormat(item.label, $i18n.locale) }}
                                ({{ item.topic.data_query[0].index.unit[`name_${language}`] }})
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>

    </v-layout>
</template>

<script>
    import SeeMore from '@/components/SeeMore'
    import Service from '../services'
    import { mapActions, mapState } from "vuex";
    import { yearFormat } from "../utils/Utils"

    export default {
        name: "StatCards",
        props: ['data'],
        components: {
          // SeeMore
        },
        computed: {
            ...mapState({
                language: state => state.locale.language
            })
        },
        data: () => ({
            // dataCardStats: [
                // { img_file: 'card1.png', qty: '9,352,595', text: 'มูลค่าการส่งออกของกลุ่ม เศรษฐกิจสร้างสรรค์ (ล้านบาท)', link: '/' },
                // { img_file: 'card2.png', qty: '104,367,846', text: 'มูลค่าของอุตสาหกรรม สร้างสรรค์ของประเทศไทย (ล้านบาท)', link: '/' },
                // { img_file: 'card3.png', qty: null, text: 'จำนวนแรงงานสร้างสรรค์ ของไทย (คน)', link: '/' }
            // ],
            yearFormat: yearFormat,
        }),
        methods: {
            sum(arrayOfNum) {
                if (Array.isArray(arrayOfNum)) {
                    let total = 0;
                    arrayOfNum.forEach((item)=> {
                        total += parseInt(item);
                    });
                    return total;
                } else {
                    return arrayOfNum;
                }
            },
            formatNumber(num) {
                return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
            }

        },
        // created() {
        //     Service.statsbox.getAllStatBox().then((res) => {
        //         this.data = res;
        //         // console.log('success', res)
        //     })
        // }
    }
</script>

<style scoped>

    .cardStats {
        border: 1px solid #FF5100 !important;
        box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
        border-radius: 0;
    }

</style>
